import { Volume2, VolumeX } from "lucide-react";
import { useExperience } from "@/context/ExperienceContext";

export function SoundToggle() {
  const { soundOn, setSoundOn } = useExperience();
  const Icon = soundOn ? Volume2 : VolumeX;
  return (
    <button data-testid="sound-toggle-btn" onClick={() => setSoundOn(!soundOn)}
      aria-pressed={soundOn} aria-label={soundOn ? "Turn sound off" : "Turn sound on"} className="rrb-sound">
      <span className="rrb-sound-icon"><Icon className="h-4 w-4" /></span>
      <span className="rrb-sound-label">{soundOn ? "Sound On" : "Sound Off"}</span>
    </button>
  );
}
